module.exports = __webpack_public_path__ + "media/images/logo4-0111996e9800971fa4bf5038cf47d6cf.png";